export const CORE_CURRENT_PROJECT_UPDATE = 'CORE_CURRENT_PROJECT_UPDATE';

// project config
export const CONFIG_CREATE_START = 'project/CONFIG_CREATE_START';
export const CONFIG_CREATE_COMPLETE = 'project/CONFIG_CREATE_COMPLETE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/actions/current-resource.ts